import type { ExternalComponentItemModel, GroupValueType } from '@libs/form/models';

export type SrmTicketSuggestionComponentId = 'srm-ticket-suggestion';
export const SRM_TICKET_SUGGESTION_COMPONENT_ID: SrmTicketSuggestionComponentId = 'srm-ticket-suggestion';

export type SrmTicketSuggestionResourceType = 'link' | 'file';

export interface SrmTicketSuggestionResourceModel {
  name: string;
  type: SrmTicketSuggestionResourceType;
  reference: string;
}

export interface SrmTicketSuggestionModel {
  available: boolean;
  text: string | null;
  resources: SrmTicketSuggestionResourceModel[];
}

export interface SrmTicketSuggestionRequestModel {
  customerNumber: string;
  form: GroupValueType;
  selectedCategories: number[];
  userUuid?: string;
}

export interface SrmTicketSuggestionItemModel extends ExternalComponentItemModel {
  componentId: SrmTicketSuggestionComponentId;
}
